import { IsNotEmpty, IsString, IsStrongPassword, Length } from 'class-validator';

export class TokenVaultResetUserPasswordDto {
  @IsString()
  @IsNotEmpty()
  @IsStrongPassword()
  @Length(8, 30)
  password!: string;

  @IsString()
  @IsNotEmpty()
  token!: string;
}
